import React from "react";
import { StateCreator } from "zustand";


export interface ActionDescriptionData {
    type: string;
    [key: string]: any
}


/** Use this to type your store set function */
// export type StoreSetFunc<T> = 
//     ((stateMods: Partial<T>, replace?: boolean | undefined, actionInfo?: string | ActionDescriptionData) => void) 
//     & ((stateModFunc: (prevState: T) => T, replace?: boolean | undefined, actionInfo?: string | ActionDescriptionData) => void);


export type StateCreatorWithDevtools<State,Slice> = StateCreator<
    State,
    [["zustand/devtools", any]],
    [],
    Slice
>;


/**
 * Use this in React Class Component to watch a Zustand store and apply changes to your local state
 * TODO: This should by typed properly but it doens't look like an easy task
 */
export class StateWatcher<StoreType, StateType> {
    private unsubsribes: (() => void)[] = [];

    constructor(private store: any, private setState: React.Dispatch<React.SetStateAction<StateType>>) { }

    /**
     * Call this to watch a field and set the change in your local state
     * @param watchField Field to watch in zustand store
     * @param localStateName Local state field to set the value
     */
    watch(watchField: keyof StoreType, localStateName: keyof StateType) {
        this.unsubsribes.push(this.store.subscribe(
            s => s[watchField], // Watch
            (val) => { 
                this.setState((prev) => ({...prev, [localStateName]: val })); // Apply in local state
            })
        );
    }

    /**
     * Call this if you need to add a custom unsubscribe function
     */
    addUnsubscribe(f: () => void) {
        this.unsubsribes.push(f);
    }

    /**
     * Call this in your componenentWillUnmount to unsubscribe all watchers
     */
    unsubscribeAll() {
        this.unsubsribes.forEach(u => u());
    }
}

//export type ReactSetType<State> = Pick<State, K extends keyof State> | State | null;


export class StoreEffect<T> {
    stateSelector: (state: T) => any;
    effect: (state: any) => void;

    constructor(watchSelector: (state: T) => any, effect: (state: any) => void) {
        this.stateSelector = watchSelector;
        this.effect = effect;
    }
}

// TODO: This could be typed correctly
export function connectStoreEffects<T>(store: T): T {
    // Find property of type StoreEffect in the store variable
    for(const key in (store as any).getState()) {
        const val = (store as any).getState()[key];
        if(val instanceof StoreEffect) {
            const field = val as StoreEffect<any>;
            (store as any).subscribe(field.stateSelector, field.effect);
        }
    }

    return store;
}